import "./References.module.css";
import Header from "@/reusable_sections/Header";
import Projektbereich from "./sections/Projektbereich";
import Footer from "@/reusable_sections/Footer";
export default function ReferencesPage() {
  return <div>
      <Header />
      <Projektbereich />
      <Footer />
    </div>;
}